import React from 'react'
import ReactDOM from 'react-dom'

import Header from 'components/header'
import Frame from 'components/frame'

import TagManager from 'react-gtm-module'
import * as Sentry from '@sentry/react';

export function Mount(children) {
    if (!Env().features.debug) {
        Sentry.init({
            dsn: Env().features.sentry,
            integrations: [
                new Sentry.Replay({
                    maskAllText: true,
                    blockAllMedia: true,
                }),
            ],
            replaysOnErrorSampleRate: 1.0,
            replaysSessionSampleRate: 0.1,
        })
    }


    let app = (
        <>
            <Header>
                {Env().features.debug ? Env().name : ''}
            </Header>
            <Frame>
                {children}
            </Frame>
        </>
    )

    if (Env().features.debug) {
        app = <React.StrictMode>{app}</React.StrictMode>
    }

    ReactDOM.render(app, document.getElementById('root'))
}

export function GTM() {
    if (Env().features.gtm) TagManager.initialize({ gtmId: Env().features.gtm })
}

export function Hotjar() {
    if (!Env().features.hotjar) return

    (function (h, o, t, j, a, r) {
        h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments) };
        h._hjSettings = { hjid: Env().features.hotjar, hjsv: 6 };
        a = o.getElementsByTagName('head')[0];
        r = o.createElement('script'); r.async = 1;
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        a.appendChild(r);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
}

export function Env() {
    const env = window.location.hostname.replace(/^(www|mercadolivre|vip)\./, '').split('.')[0];

    const production = 'instacarro'

    const query = new URLSearchParams(window.location.search)

    const features = {
        hideVenues: query.get('hideVenues') === 'true' ? true : false
    }

    const envs = {
        // production!
        [production]: {
            name: production,
            features: {
                gtm: 'GTM-59RJMJV',
                debug: false,
                experimentId: 'N83JX9YwRkudluzBYGdOTw',
                sentry: 'https://5a9671f35a8e4db5bba54251e26859b5@sentry.instacarro.com/28',
                partnerMaxDistanceKm: 0,
                autovistoriaUrl: 'https://autovistoria.instacarro.com/iniciar',
                ...features,
            },
            apis: {
                priceEstimate: 'https://apigateway.instacarro.com/api/sellers_price/v1',
                appointments: 'https://api.instacarro.com/sellers/v2',
                sms: 'https://c2c.instacarro.com/v1/customers/v1/sms',
                contactValidation: "https://api.instacarro.com/sellers_v3/contact-validation",
                sellersV2: 'https://api.instacarro.com/sellers/v2',
            },
            auth: {
                contactValidation: {
                    username: "contactValidation",
                    password: "S@d9p@2qG5$L3K7z",
                }
            }
        },
        // test
        sandbox: {
            name: env,
            features: {
                gtm: 'GTM-PFMFL9D',
                debug: true,
                experimentId: '5GK9Vh8pQbK3Q2tgRY59gw',
                partnerMaxDistanceKm: 0,
                autovistoriaUrl: 'https://autovistoria.instacarro.com/iniciar',
                ...features,
            },
            apis: {
                priceEstimate: 'https://sandbox-api.instacarro.com/api/sellers_price/v1',
                appointments: 'https://sandbox-api.instacarro.com/sellers/v2',
                sms: 'https://sandbox.c2c.instacarro.com/v1/customers/sms',
                sellersV2: 'https://sandbox-api.instacarro.com/sellers/v2',
                contactValidation: "https://sandbox-api.instacarro.com/sellers_v3/contact-validation",
            },
            auth: {
                contactValidation: {
                    username: "contactValidation",
                    password: "l@GuA$b2ja@zy?79",
                }
            }
        },
        // dev
        localhost: {
            name: env,
            features: {
                gtm: 'GTM-PFMFL9D',
                debug: true,
                experimentId: '5GK9Vh8pQbK3Q2tgRY59gw',
                partnerMaxDistanceKm: 0,
                autovistoriaUrl: 'https://autovistoria.instacarro.com/iniciar',
                ...features,
            },
            apis: {
                priceEstimate: 'https://sandbox-api.instacarro.com/api/sellers_price/v1',
                appointments: 'https://sandbox-api.instacarro.com/sellers/v2',
                sms: 'https://sandbox.c2c.instacarro.com/v1/customers/sms',
                sellersV2: 'https://sandbox-api.instacarro.com/sellers/v2',
                contactValidation: "https://sandbox-api.instacarro.com/sellers_v3/contact-validation",
            },
            auth: {
                contactValidation: {
                    username: "contactValidation",
                    password: "l@GuA$b2ja@zy?79",
                }
            }
        },
    }

    const config = envs[env] ?? envs['localhost']

    // allow overriding env based on localstorage config for debug envs only
    if (config.name !== production && localStorage.getItem('env')) return envs[localStorage.getItem('env')]

    return config
}